import { useState } from "react";
import * as S from "./styles.ts";
import { TBillingInterval } from "@/redux/slices/user/types.ts";
import useCurrency from "@/lib/helpers/hooks/useCurrency.ts";

interface IRenewalPeriod {
  renewalPeriod: string;
  setRenewalPeriod: (value: TBillingInterval) => void;
  isCompare?: boolean;
}

const ToggleSwitch = ({
  renewalPeriod,
  setRenewalPeriod,
  isCompare,
}: IRenewalPeriod) => {
  const currency = useCurrency();
  return (
    <S.Container>
      <S.LabelText $isCompare={isCompare}>
        {currency === "$" ? "Get 20% " : "Get up to 25% "}off with yearly
      </S.LabelText>
      <S.ToggleWrapper>
        <S.ToggleContainer>
          <S.ToggleButton
            $active={renewalPeriod === "monthly"}
            onClick={() => setRenewalPeriod("monthly")}
            $isLeft
          >
            Monthly
          </S.ToggleButton>
          <S.ToggleButton
            $active={renewalPeriod === "yearly"}
            onClick={() => setRenewalPeriod("yearly")}
            $isRight
          >
            Yearly
          </S.ToggleButton>
        </S.ToggleContainer>
      </S.ToggleWrapper>
    </S.Container>
  );
};

export default ToggleSwitch;
